module.exports = __webpack_public_path__ + "static/media/12-hm-chairs-08_31_2020.caf19a74.jpg";